import { system } from 'styled-system';
import { transparentize } from 'polished';
import { palette } from '../../../../palette';

export const boxShadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'colors',
    transform: (value, scale: typeof palette) => {
      const color = transparentize(0.85, scale['black']['dark']);
      if (value === 'top') {
        return `inset 0 6px 4px -4px ${color}`;
      }
      if (value === 'top-bottom') {
        return `inset 0 6px 4px -4px ${color}, inset 0 -6px 4px -4px ${color}`;
      }
      if (value === 'bottom') {
        return `inset 0 -6px 4px -4px ${color}`;
      }
      return 'none';
    },
  },
});
